/**
 * `core/barba/utils/barbaThreeSceneObserver.js`
 * - Three.js シーンインスタンスを監視・管理
 *
 * 使用方法:
 * - import {barbaEventObserver} from "./core/barba/utils/barbaEventObserver.js";
 */


export const barbaThreeSceneObserver = {
  sceneInstance: null,

  /**
   * Three.js シーンインスタンスを登録
   * @param {Object} instance - ParticleScene などの Three.js クラスインスタンス
   */
  setScene(instance) {
    this.sceneInstance = instance;
  },

  /**
   * Three.js シーンインスタンスを取得
   */
  getScene() {
    return this.sceneInstance;
  },

  /**
   * Three.js シーンインスタンスを破棄（あれば destroy 実行）
   */
  destroyScene() {
    if (this.sceneInstance && typeof this.sceneInstance.destroy === 'function') {
      this.sceneInstance.destroy();
    }
    this.sceneInstance = null;
  },
};